export default [
  {
    'elementType': 'labels.icon',
    'stylers': [
      {
        'saturation': -100,
      },
      {
        'visibility': 'off',
      },
    ],
  },
  {
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#a1a195',
      },
    ],
  },
  {
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#ffffff',
      },
    ],
  },
  {
    'featureType': 'landscape.natural',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'saturation': -55,
      },
      {
        'lightness': 40,
      },
    ],
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ebebdf',
      },
    ],
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefef9',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'road.local',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#fefef9',
      },
    ],
  },
  {
    'featureType': 'transit',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#d7d7cd',
      },
      {
        'lightness': 20,
      },
    ],
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'saturation': -40,
      },
      {
        'lightness': 75,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./scripts/util/mapStyles.js